import styled from 'styled-components';

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Descricao = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.grey_text};
  margin-bottom: 10px;
`;

export const ButtonContainer = styled.div`
  margin-top: 10px;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const SuccessMessage = styled.div<{ isError?: boolean }>`
  background-color: ${props => props.isError 
    ? props.theme.colors.error_light 
    : props.theme.colors.success_light};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 10px;
  
  p {
    margin: 6px 0;
    font-size: 14px;
    color: ${props => props.theme.colors.text};
  }
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  margin-bottom: 16px;
`;